// 引入可拖拽组件
import imgComponent from "@/components/ProductComponents/CreateComponents/specificComponents/imgComponent";
import WaterLineComponent from "@/components/ProductComponents/CreateComponents/specificComponents/WaterLineComponent";
import buttonComponent from "@/components/ProductComponents/CreateComponents/specificComponents/buttonComponent";
import rectangleComponent from "@/components/ProductComponents/CreateComponents/specificComponents/rectangleComponent";
import circleComponent from "@/components/ProductComponents/CreateComponents/specificComponents/circleComponent";
import triangleComponent from "@/components/ProductComponents/CreateComponents/specificComponents/triangleComponent";
import arrowComponent from "@/components/ProductComponents/CreateComponents/specificComponents/arrowComponent";
import wheelComponent from "@/components/ProductComponents/CreateComponents/specificComponents/wheelComponent"
import dynamicLabelComponent from "@/components/ProductComponents/CreateComponents/specificComponents/dynamicLabelComponent";
import crossTwoComponent from "@/components/ProductComponents/CreateComponents/specificComponents/crossTwoComponent.vue";
import crossTwoAngleComponent from "@/components/ProductComponents/CreateComponents/specificComponents/crossTwoAngleComponent.vue";
import crossThreeComponent from "@/components/ProductComponents/CreateComponents/specificComponents/crossThreeComponent.vue";
import crossFourComponent from "@/components/ProductComponents/CreateComponents/specificComponents/crossFourComponent.vue";
import cameraComponent from "@/components/ProductComponents/CreateComponents/specificComponents/cameraComponent.vue";
// type和可拖拽组件的映射，key为type，value为组件
let typeComponentMap = {
  "img": imgComponent,
  "WaterLine": WaterLineComponent,
  "button": buttonComponent,
  "rectangle": rectangleComponent,
  "triangle": triangleComponent,
  "circle": circleComponent,
  "arrow": arrowComponent,
  "wheel": wheelComponent,
  'dynamicLabel': dynamicLabelComponent,
  'crossTwo': crossTwoComponent,
  'crossTwoAngle':crossTwoAngleComponent,
  'crossThree': crossThreeComponent,
  'crossFour': crossFourComponent,
  'camera': cameraComponent,
}

// 引入可拖拽组建的编辑器
import imgEditor from "@/components/ProductComponents/CreateComponents/specificEditor/imgEditor";
import WaterLineEditor from "@/components/ProductComponents/CreateComponents/specificEditor/WaterLineEditor";
import buttonEditor from "@/components/ProductComponents/CreateComponents/specificEditor/buttonEditor";
import RectangleEditor from "@/components/ProductComponents/CreateComponents/specificEditor/RectangleEditor";
import circleEditor from "@/components/ProductComponents/CreateComponents/specificEditor/circleEditor";
import arrowEditor from "@/components/ProductComponents/CreateComponents/specificEditor/arrowEditor";
import triangleEditor from "@/components/ProductComponents/CreateComponents/specificEditor/triangleEditor";
import wheelEditor from "@/components/ProductComponents/CreateComponents/specificEditor/wheelEditor";
import dynamicLabelEditor from "@/components/ProductComponents/CreateComponents/specificEditor/dynamicLabelEditor";
import crossTwoEditor from "@/components/ProductComponents/CreateComponents/specificEditor/crossTwoEditor";
import crossTwoAngleEditor from "@/components/ProductComponents/CreateComponents/specificEditor/crossTwoAngleEditor";
import crossThreeEditor from "@/components/ProductComponents/CreateComponents/specificEditor/crossThreeEditor";
import crossFourEditor from "@/components/ProductComponents/CreateComponents/specificEditor/crossFourEditor";
import cameraEditor from "@/components/ProductComponents/CreateComponents/specificEditor/cameraEditor";
// type和编辑器的映射，key为type，value为编辑器组件
let typeEditorMap = {
  'img': imgEditor, // 还没写，先用div代替
  "WaterLine": WaterLineEditor,
  "button": buttonEditor,
  "rectangle": RectangleEditor,
  "circle": circleEditor,
  "arrow": arrowEditor,
  "wheel": wheelEditor,
  "triangle": triangleEditor,
  'dynamicLabel': dynamicLabelEditor,
  'crossTwo': crossTwoEditor,
  'crossTwoAngle':crossTwoAngleEditor,
  'crossThree': crossThreeEditor,
  'crossFour': crossFourEditor,
  'camera': cameraEditor
}
export {typeComponentMap, typeEditorMap}